const TRAILING_PUNCTUATION = new Set([".", ",", ";", ":", "!", "?"]);

const HTTP_URL_PATTERN = /(?<![A-Za-z0-9])https?:\/\/[^\s<>"`]+/gi;

const HTTP_URL = /^https?:\/\/\S+$/i;

export type HttpUrlSegment =
  | { kind: "text"; text: string }
  | { kind: "url"; text: string };

/**
 * Splits plain text into literal runs and http(s) URLs.
 * Only http and https are linkified; other schemes stay literal so they cannot be navigated.
 */
export function splitHttpUrls(value: string): HttpUrlSegment[] {
  const segments: HttpUrlSegment[] = [];
  const pattern = new RegExp(HTTP_URL_PATTERN.source, HTTP_URL_PATTERN.flags);
  let cursor = 0;

  for (const match of value.matchAll(pattern)) {
    const start = match.index ?? 0;
    const url = trimTrailingUrlPunctuation(match[0]);
    if (!HTTP_URL.test(url) || start < cursor) {
      continue;
    }
    if (start > cursor) {
      segments.push({ kind: "text", text: value.slice(cursor, start) });
    }
    segments.push({ kind: "url", text: url });
    cursor = start + url.length;
  }

  if (cursor < value.length) {
    segments.push({ kind: "text", text: value.slice(cursor) });
  }

  return segments;
}

function trimTrailingUrlPunctuation(raw: string): string {
  let end = raw.length;
  while (end > 0 && shouldTrimTrailingUrlChar(raw, end)) {
    end -= 1;
  }
  return raw.slice(0, end);
}

function shouldTrimTrailingUrlChar(raw: string, end: number): boolean {
  const char = raw[end - 1];
  if (TRAILING_PUNCTUATION.has(char)) {
    return true;
  }
  if (char === ")") {
    const head = raw.slice(0, end);
    return countChar(head, ")") > countChar(head, "(");
  }
  if (char === "]") {
    const head = raw.slice(0, end);
    return countChar(head, "]") > countChar(head, "[");
  }
  if (char === "'") {
    const head = raw.slice(0, end);
    return countChar(head, "'") % 2 === 1;
  }
  return false;
}

function countChar(value: string, char: string): number {
  let count = 0;
  for (const current of value) {
    if (current === char) {
      count += 1;
    }
  }
  return count;
}
